import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchCurrentUser } from "../api/userService";
export var useGetCurrentUser = function () {
    var ky = useOkapiKy();
    return useQuery(["currentUser"], function () { return fetchCurrentUser(ky); }, {
        enabled: true,
        staleTime: 0,
        cacheTime: 0,
        refetchOnWindowFocus: true,
        refetchOnMount: true,
    });
};
